import React from "react"
import "./HomeVideo.module.css"

const HomeVideo = () => {
  return (
    <div className="video">
      <div className="ratio ratio-16x9">
        <iframe
          src="https://www.youtube.com/embed/dU0k34bpQhc?controls=0&loop=1&modestbranding=1&rel=0"
          title="CSI Introduction Video"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope"
          allowFullScreen
        />
      </div>
    </div>
  )
}

export default HomeVideo
